import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { ValidatorFn } from "@angular/forms";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-side-filters',
  templateUrl: './side-filters.component.html',
  styleUrls: ['./side-filters.component.css']
})
export class SideFiltersComponent implements OnInit {
  toDatee: string;
  fromDatee: string;
  PageName: string;
  sideactiveAll:any;
  sideactiveOpen:any='side-active';;
  sideactiveClosed:any;

  @Output() childButtonEvent = new EventEmitter();
  @Output() onInitEvent = new EventEmitter();

  constructor() { }

  clickHandlerAll() {
    var status=('All');
    this.sideactiveAll='side-active';
    this.sideactiveOpen='';
    this.sideactiveClosed='';
    this.childButtonEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee , status });
  }

  clickHandlerOpen() {
    var status=('Open');
    this.sideactiveOpen='side-active';
    this.sideactiveAll='';
    this.sideactiveClosed='';
    this.childButtonEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee , status });
  }


  clickHandlerClosed() {
    var status=('Closed');
    this.sideactiveClosed='side-active';
    this.sideactiveAll='';
    this.sideactiveOpen='';
    this.childButtonEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee , status });
  }

  fromDate() {
    var status
    if (this.sideactiveClosed != undefined) {
      if (this.sideactiveClosed != '') {
        status = 'Closed'
        this.sideactiveClosed = 'side-active';
        this.sideactiveAll = '';
        this.sideactiveOpen = '';
      }

    }
    if (this.sideactiveOpen != undefined) {
      if (this.sideactiveOpen != '') {
        status = 'Open'
        this.sideactiveOpen = 'side-active';
        this.sideactiveAll = '';
        this.sideactiveClosed = '';
      }

    }
    if (this.sideactiveAll != undefined) {
      if (this.sideactiveAll != '') {
        status = 'All'
        this.sideactiveAll = 'side-active';
        this.sideactiveOpen = '';
        this.sideactiveClosed = '';
      }


    }

    this.childButtonEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee, status });
  }

  toDate() {
    var status
    if (this.sideactiveClosed != undefined) {
      if (this.sideactiveClosed != '') {
        status = 'Closed'
        this.sideactiveClosed = 'side-active';
        this.sideactiveAll = '';
        this.sideactiveOpen = '';
      }

    }
    if (this.sideactiveOpen != undefined) {
      if (this.sideactiveOpen != '') {
        status = 'Open'
        this.sideactiveOpen = 'side-active';
        this.sideactiveAll = '';
        this.sideactiveClosed = '';
      }

    }
    if (this.sideactiveAll != undefined) {
      if (this.sideactiveAll != '') {
        status = 'All'
        this.sideactiveAll = 'side-active';
        this.sideactiveOpen = '';
        this.sideactiveClosed = '';
      }


    }

    this.childButtonEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee , status });
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  ngOnInit(): void {

    //hide status filter for superverifier
    this.PageName = window.location.pathname;
    // const httpParams = new HttpParams({ fromString: url.split('/')[1] });
    //var eet = httpParams.get('emailId');

    let d = new Date();
    let sevenDaysFromNow = d.setDate(d.getDate() - 30);
    // this.fromDatee = new Date(sevenDaysFromNow).toISOString().split('T')[0];
    this.fromDatee = formatDate(new Date(sevenDaysFromNow), 'yyyy-MM-dd', 'en-US');
    //alert('formatDate ' +this.fromDatee);
    // this.toDatee = new Date().toISOString().split('T')[0];
    this.toDatee = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');

    // alert(this.toDatee);
    // this.fromDatee = new Date().toISOString().split('T')[0];
    this.onInitEvent.emit({ fromDatee: this.fromDatee, toDatee: this.toDatee });
    //this.onInitEvent.emit(this.toDatee );
  }





}
